import $ from 'cash-dom';

/**
 * This module ajax fetches more articles
 */
export class ArticlesModule {

    static name = 'articles';

    constructor(node) {

        this.node = node;
        this.offset = 2;
        this.loading = false;
        this.totalCount = parseInt($(node).data('count')) || 0;
        this.container = $('.articles-js');

        $(node).on('click', this.handleClick);
    }

    handleClick = (e) => {

        e.preventDefault();

        if(this.loading) return;
        this.loading = true;
        $(this.node).addClass('loading');

        const url = $(this.node).attr('href');
        window.fetch(`${url}?fetch&offset=${this.offset}`)
            .then(response => response.text())
            .then(html => {
                
                this.offset += 4;
                this.container.append(html);

                if(this.offset >= this.totalCount) {
                    $(this.node)
                        .text('show less')
                        .off('click', this.handleClick)
                        .on('click', this.handleReset);
                }
            })
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                this.loading = false;
                $(this.node).removeClass('loading');
            });
    }

    handleReset = (e) => {

        e.preventDefault();
        
        $(this.node)
            .text('show more')
            .off('click', this.handleReset)
            .on('click', this.handleClick);
        
        this.offset = 2;    
        this.container.find('article').slice(2).remove();
    }
}